// @flow

import type {MarkdocTagRegistration} from 'docs/markdoc';

export const CountryFlagListTag: MarkdocTagRegistration = {
  tag: 'country-flag-list',
  component: 'CountryFlagList',
  selfClosing: true,
  attributes: {
    countries: {
      type: Array,
      required: true,
      description:
        'List of ISO Alpha-2 country codes of all supported countries',
    },
    betaCountries: {
      type: Array,
      required: false,
      description:
        'List of ISO Alpha-2 country codes of all supported beta countries',
    },
    asteriskCountries: {
      type: Array,
      required: false,
      description:
        'List of ISO Alpha-2 country codes for the countries that should have an asterisk next to their name',
    },
    countryDisplayNames: {
      type: Array,
      required: true,
      description: 'A map of ISO country code <> formatted country name',
    },
    size: {
      type: String,
      required: false,
      description: 'The size of the flags and country names',
    },
  },
};
